import React from 'react';
import './Footer.css';
import { NavLink } from 'react-router-dom';
import logoConexs from '../assets/icono/logo192Negativo.png'

function Footer() {
  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo */}
        <div className='content-footer'>
          <div>
            <img src={logoConexs} className='footer-logo' alt="Conexs Logo" />
          </div>

          <div className='text-footer'>
            {/* Navegación */}
            <div className="footer-navigation">
              <a
                onClick={() => handleScrollToSection("servicios")}
                className="footer-link"
              >
                Servicios
                <div className="line-navbar"></div>
              </a>
              <a
                onClick={() => handleScrollToSection("nosotros")}
                className="footer-link"
              >
                Nosotros
                <div className="line-navbar"></div>
              </a>
              <a
                onClick={() => handleScrollToSection("beneficios")}
                className="footer-link"
              >
                Beneficios
                <div className="line-navbar"></div>
              </a>
              <a
                onClick={() => handleScrollToSection("como-funciona")}
                className="footer-link"
              >
                Cómo Funciona
                <div className="line-navbar"></div>
              </a>
              <a
                onClick={() => handleScrollToSection("comienza")}
                className="footer-link"
              >
                Contacto
                <div className="line-navbar"></div>
              </a>
            </div>
            {/* Política de Privacidad */}
          </div>
        </div>

        {/* Derechos Reservados */}
        <div className="footer-rights">
          <div className='line-footer'></div>
          <div className="footer-legal">
            <NavLink
              to="/privacy-policy"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Políticas de Privacidad
            </NavLink>
            <p className='text-rights'>© 2025 Conexs. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;